// --------------------------------------------------------------------------
// #? Apple Pay module
// --------------------------------------------------------------------------
// Author:      RSPB
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var braintree = require('braintree-web');

module.exports = function (options) {
  var ref = { $root: options.context, $document: jQuery(document) };
  var $form = $(document).find('.donation-form form'),
      currentUrl = $form.find('#CurrentPageUrl').val(),
      $appleButton = ref.$root.find('[data-name="apple-pay"]'),
      clientTokenUrl = '/BraintreeToken',
      donationAmount = 0,

  // form fields
  $payWithApplePay = $form.find('input[name="PaymentOptions.PayWithApplePay"]'),
      $braintreeNonce = $form.find('input[name="PaymentOptions.BraintreeNonce"]'),

  // contact fields
  $title = $form.find('[data-binding="contact-details-title"]'),
      $firstName = $form.find('[data-binding="contact-details-first-name"]'),
      $lastName = $form.find('[data-binding="contact-details-last-name"]'),
      $email = $form.find('[data-binding="contact-details-email-address"]'),
      $mobileNumber = $form.find('[data-binding="contact-details-mobile-number"]'),
      $addressLine1 = $form.find('input[name="ContactDetails.Address.AddressLine1"]'),
      $addressLine2 = $form.find('input[name="ContactDetails.Address.AddressLine2"]'),
      $addressLine3 = $form.find('input[name="ContactDetails.Address.AddressLine3"]'),
      $addressTown = $form.find('[data-binding="address-part-town"]'),
      $addressCounty = $form.find('[data-binding="address-part-county"]'),
      $addressPostcode = $form.find('[data-binding="address-part-postcode"]'),
      $addressCountry = $form.find('[data-binding="address-part-country"]'),
      $ddAccountName = $form.find('input[name="PaymentOptions.AccountName"]'),
      $ddAccountNumber = $form.find('input[name="PaymentOptions.AccountNumber"]'),
      $ddSortCode1 = $form.find('input[name="PaymentOptions.SortCode1"]'),
      $ddSortCode2 = $form.find('input[name="PaymentOptions.SortCode2"]'),
      $ddSortCode3 = $form.find('input[name="PaymentOptions.SortCode3"]'),

  // error message
  $errorMessage = $form.find('[data-valmsg-for="PaymentOptions.ApplePay"] span');

  var generaErrorlMessage = 'Apple Pay is temporarily not available.<br>Please use below "Pay with card" option.',
      paymentErrorMessage = 'There was an error with your Apple Pay payment.<br>Your card was not charged.';

  // handler for 'donation-amount-confirmation:change' event
  function onDonationAmountChange(event, amount, monthly) {
    // monthly donations are not supported, return 0
    donationAmount = !monthly ? amount : 0;

    if (!monthly) {
      if (donationAmount < 1) {
        $appleButton.addClass('disabled');
      } else {
        $appleButton.removeClass('disabled');
      }
    }
  }

  function hideError() {
    $errorMessage.parent().removeClass('visible');
    $errorMessage.html('');
  }

  function showError(message) {
    $errorMessage.parent().addClass('visible');
    $errorMessage.html(message);
  }

  function init() {
    // action only if ApplePay is available
    if (window.ApplePaySession) {

      // requires an HTTPS connection from an HTTPS source
      $.get(clientTokenUrl).done(function (tokenResults) {
        if (typeof tokenResults.Token === 'undefined' || !tokenResults.Token) {
          console.error('No token for initialisation.');
          showError(generaErrorlMessage);
          return;
        }

        var clientToken = tokenResults.Token;

        braintree.client.create({
          authorization: clientToken
        }, function (clientErr, clientInstance) {
          if (clientErr) {
            console.error('Error creating client:', clientErr);
            showError(generaErrorlMessage);
            return;
          }

          braintree.applePay.create({
            client: clientInstance
          }, function (applePayErr, applePayInstance) {
            if (applePayErr) {
              console.error('Error creating applePayInstance:', applePayErr);
              showError(generaErrorlMessage);
              return;
            }

            var promise = window.ApplePaySession.canMakePaymentsWithActiveCard(applePayInstance.merchantIdentifier);
            promise.then(function (canMakePaymentsWithActiveCard) {
              if (canMakePaymentsWithActiveCard) {
                // Set up Apple Pay buttons
                $appleButton.addClass('available');
                // Once the class is set (wait for the next JS cycle), notify listeners (change-payment.js)
                ref.$document.trigger('apple-pay:available', true);

                // take initial donatoin value from data-donation attribute in case no events trigger
                donationAmount = $('[data-donation]').html();

                // if there's no default value for data-donation attribute reset to zero
                if (donationAmount === 'null') {
                  donationAmount = 0;
                  // manually call the handler to grey out the Apple Pay button
                  onDonationAmountChange(null, donationAmount, false);
                }

                // set handler for amount donation and type of donation (monthly/one-off) changes
                $(document).on('donation-amount-confirmation:change', onDonationAmountChange);

                $appleButton.click(function () {
                  // remove any previous error messages
                  hideError();

                  // payment
                  var paymentRequest = applePayInstance.createPaymentRequest({
                    total: {
                      label: 'One-off donation',
                      amount: parseFloat(donationAmount).toFixed(2)
                    },
                    countryCode: 'GB',
                    currencyCode: 'GBP',
                    requiredBillingContactFields: ['postalAddress', 'name'],
                    requiredShippingContactFields: ['email', 'phone'],
                    supportedNetworks: ['visa', 'masterCard']
                  });

                  // use version 1 of Apple Pay Session object
                  var session = new window.ApplePaySession(1, paymentRequest);

                  session.onvalidatemerchant = function (event) {
                    applePayInstance.performValidation({
                      validationURL: event.validationURL,
                      displayName: 'RSPB'
                    }, function (validationErr, merchantSession) {
                      if (validationErr) {
                        // You should show an error to the user, e.g. 'Apple Pay failed to load.'
                        console.error('Error validating merchant:', validationErr);
                        session.abort();
                        showError(paymentErrorMessage);
                        return;
                      }
                      session.completeMerchantValidation(merchantSession);
                    });
                  };

                  session.onpaymentauthorized = function (event) {

                    applePayInstance.tokenize({
                      token: event.payment.token
                    }, function (tokenizeErr, payload) {
                      if (tokenizeErr) {
                        console.error('Error tokenizing Apple Pay:', tokenizeErr);
                        session.completePayment(window.ApplePaySession.STATUS_FAILURE);
                        showError(paymentErrorMessage);
                        return;
                      }
                      session.completePayment(window.ApplePaySession.STATUS_SUCCESS);

                      // change form's action to the current page (instead to default Authorize for one-off donations)
                      $form.attr('action', currentUrl);

                      // fill the Donation form with data gathered from Apple Pay customer
                      $payWithApplePay.val('True');
                      $braintreeNonce.val(payload.nonce);
                      $title.find('option:eq(1)').prop('selected', 'selected'); // select second option (ignore first "Please select" one)
                      // info from shipping
                      $email.val(event.payment.shippingContact.emailAddress);
                      $mobileNumber.val(event.payment.shippingContact.phoneNumber);
                      // info from billing
                      $firstName.val(event.payment.billingContact.givenName);
                      $lastName.val(event.payment.billingContact.familyName);
                      $addressLine1.val(event.payment.billingContact.addressLines[0]);
                      $addressLine2.val(event.payment.billingContact.addressLines[1]);
                      $addressLine3.val(event.payment.billingContact.addressLines[2]);
                      $addressTown.val(event.payment.billingContact.locality);
                      $addressCounty.val(event.payment.billingContact.administrativeArea);
                      $addressPostcode.val(event.payment.billingContact.postalCode);

                      var $selectedCountry = $addressCountry.find('option[value="' + event.payment.billingContact.country + '"]');
                      if ($selectedCountry.length === 0) {
                        // if the country is not found use UK
                        $selectedCountry = $addressCountry.find('option[value="United Kingdom"]');
                      }
                      $selectedCountry.prop('selected', 'selected');

                      // fill dummy values to validate JavaScript validation of the form
                      $ddAccountName.val('Apple Pay');
                      $ddAccountNumber.val('111111111');
                      $ddSortCode1.val('11');
                      $ddSortCode2.val('11');
                      $ddSortCode3.val('11');

                      // have to be added to be processed by back-end
                      $form.append('<input type="hidden" name="Submit" />');

                      // submit the form
                      $form.submit();
                    });
                  };

                  session.begin();
                });
              } else {
                // if Braintree account hasn't got the domain listed in processing dashboard
                // it will also stop here
                console.log('Sorry, you cannot make payments right now');
              }
            });
          });
        }); // braintree.client.create
      }); // end of $.get(token)
    } // window.ApplePaySession
  }

  return {
    init: init
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/apple-pay.js
// module id = 284
// module chunks = 0